import { render, staticRenderFns } from "./AddStApplicant.vue?vue&type=template&id=871fd032&"
import script from "./AddStApplicant.vue?vue&type=script&lang=js&"
export * from "./AddStApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports